import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useStore } from '../lib/store';
import { VENDOR_CATEGORIES } from '../lib/checklists';
import { BackBar, Field, inputCls, EASE } from '../components/Bits';

export default function AddVendor() {
  const { state, addVendor } = useStore();
  const navigate = useNavigate();
  const [saved, setSaved] = useState(null);
  const [f, setF] = useState({ name: '', category: 'WO', pic: '', phone: '', value: '', notes: '', website: '', location: '' });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!f.name.trim()) return;
    const vendor = { ...f, name: f.name.trim(), value: Number(f.value) || 0 };
    addVendor(vendor);
    const created = state.vendors[state.vendors.length - 1];
    setSaved(vendor.name);
    setTimeout(() => {
      const list = JSON.parse(localStorage.getItem('nikahrapi_v1'))?.vendors || [];
      const found = [...list].reverse().find((v) => v.name === vendor.name);
      if (found) navigate(`/app/vendor/${found.id}`, { replace: true });
      else navigate('/app/vendor', { replace: true });
    }, 1400);
    void created;
  };

  if (saved) {
    return (
      <div className="pt-16 text-center">
        <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.5, ease: EASE }}>
          <CheckCircle2 size={44} className="mx-auto text-sage" strokeWidth={1.5} />
          <h1 data-testid="add-vendor-success" className="mt-5 font-serif text-2xl font-semibold text-ink">Vendor sudah dicatat.</h1>
          <p className="mt-2 text-sm text-slate-500">Sip. Satu urusan lagi sudah lebih rapi. Sekarang cek hal pentingnya.</p>
          <p className="mt-6 inline-flex items-center gap-2 text-xs font-bold text-terra">Membuka Vendor Verify <ArrowRight size={13} /></p>
        </motion.div>
      </div>
    );
  }

  return (
    <div data-testid="add-vendor-page">
      <BackBar to="/app/vendor" title="Tambah Vendor" />
      <h1 className="font-serif text-2xl font-semibold tracking-tight text-ink">Vendor baru</h1>
      <p className="mt-1.5 text-sm text-slate-500">Singkat saja. Detail pengecekan menyusul di Vendor Verify.</p>
      <form onSubmit={submit} className="mt-6 space-y-4">
        <Field label="Nama vendor">
          <input data-testid="vendor-name-input" className={inputCls} placeholder="Nama usaha vendor" value={f.name} onChange={set('name')} required />
        </Field>
        <Field label="Kategori">
          <select data-testid="vendor-category-select" className={inputCls} value={f.category} onChange={set('category')}>
            {VENDOR_CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </Field>
        <Field label="Nama PIC">
          <input data-testid="vendor-pic-input" className={inputCls} placeholder="Kontak utama vendor" value={f.pic} onChange={set('pic')} />
        </Field>
        <Field label="Nomor kontak">
          <input data-testid="vendor-phone-input" className={inputCls} placeholder="08xx-xxxx-xxxx" value={f.phone} onChange={set('phone')} />
        </Field>
        <Field label="Nilai kerja sama" optional>
          <input data-testid="vendor-value-input" type="number" min="0" className={inputCls} placeholder="60000000" value={f.value} onChange={set('value')} />
        </Field>
        <Field label="Website / Instagram" optional>
          <input data-testid="vendor-website-input" className={inputCls} placeholder="@vendor" value={f.website} onChange={set('website')} />
        </Field>
        <Field label="Lokasi" optional>
          <input data-testid="vendor-location-input" className={inputCls} placeholder="Kota" value={f.location} onChange={set('location')} />
        </Field>
        <Field label="Catatan" optional>
          <textarea data-testid="vendor-notes-input" rows={3} className={inputCls} placeholder="Detail paket, hasil obrolan, dll." value={f.notes} onChange={set('notes')} />
        </Field>
        <button data-testid="vendor-save-btn" type="submit" className="w-full rounded-full bg-ink text-ivory py-4 text-sm font-bold hover:bg-inkdeep transition-colors">
          Simpan Vendor
        </button>
      </form>
    </div>
  );
}
